export enum InputStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETE = 'COMPLETE',
  ERROR = 'ERROR',
  RECEIVED = 'RECEIVED',
  RESPONDED = 'RESPONDED',
}

export type FetchConfig = {
  fetchImplementation: typeof fetch;
  numRetries: number;
};
